/* ============================================================================
   KIKI & JOJO — Product page enhancements
   ============================================================================ */
(function () {
  'use strict';
  if (window.__kjProductCROInit) return;
  window.__kjProductCROInit = true;

  if (!document.body.classList.contains('template-product')) {
    document.body.classList.add('template-product');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    document.body.classList.add('template-product');
    setupStickyAtc();
    setupColorSwatchMap();
    setupFabricPicker();
    setupVariantSync();
  }

  function setupVariantSync() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return;
    var scripts = vs.querySelectorAll('script[type="application/json"]');
    var variants = null;
    scripts.forEach(function (s) {
      try {
        var data = JSON.parse(s.textContent);
        if (Array.isArray(data) && data.length > 0 && data[0].id && data[0].option1 !== undefined) {
          variants = data;
        }
      } catch (e) {}
    });
    if (!variants || !variants.length) return;
    var atc = document.querySelector('.kj-pdp__atc');
    var atcLabel = document.querySelector('.kj-pdp__atc-label');
    function findVariant() {
      var selectedByPosition = {};
      var radios = vs.querySelectorAll('input[type="radio"]:checked');
      radios.forEach(function (r) {
        var nameMatch = r.name.match(/-(\d+)$/);
        if (nameMatch) selectedByPosition[parseInt(nameMatch[1], 10)] = r.value;
      });
      return variants.find(function (v) {
        for (var i = 1; i <= 4; i++) {
          var opt = v['option' + i];
          if (opt && selectedByPosition[i] && opt !== selectedByPosition[i]) return false;
          if (opt && !selectedByPosition[i]) return false;
        }
        return true;
      });
    }
    function syncFromVariant(variant) {
      if (!variant) return;
      document.querySelectorAll('input[name="id"]').forEach(function (input) {
        input.value = variant.id;
        if (!variant.available) input.setAttribute('disabled', 'disabled');
        else input.removeAttribute('disabled');
      });
      try {
        var url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } catch (e) {}
      var priceCurrent = document.querySelector('.kj-pdp__price-sale');
      var priceCompare = document.querySelector('.kj-pdp__price-compare');
      var pricePct = document.querySelector('.kj-pdp__price-pct');
      if (priceCurrent && typeof variant.price === 'number') {
        priceCurrent.textContent = formatMoney(variant.price);
      }
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (priceCompare) {
          priceCompare.textContent = formatMoney(variant.compare_at_price);
          priceCompare.style.display = '';
        }
        if (pricePct) {
          var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          pricePct.textContent = '−' + pct + '%';
          pricePct.style.display = '';
        }
      } else {
        if (priceCompare) priceCompare.style.display = 'none';
        if (pricePct) pricePct.style.display = 'none';
      }
      if (atc && atcLabel) {
        if (variant.available) {
          atc.disabled = false;
          atcLabel.textContent = 'Add to Bag';
        } else {
          atc.disabled = true;
          atcLabel.textContent = 'Sold Out';
        }
      }
      var colorVal = document.querySelector('.kj-pdp__opt--color .kj-pdp__opt-value');
      if (colorVal && variant.option1) colorVal.textContent = variant.option1.split(' - ')[0];
      var sizeVal = document.querySelector('.kj-pdp__opt--pill:not(.kj-pdp__opt--variant-fabric) .kj-pdp__opt-value');
      if (sizeVal && variant.option2) sizeVal.textContent = variant.option2;
    }
    function formatMoney(cents) {
      if (typeof cents !== 'number') cents = parseInt(cents, 10);
      return '$' + (cents / 100).toFixed(2);
    }
    vs.addEventListener('change', function () {
      setTimeout(function () { syncFromVariant(findVariant()); }, 0);
    });
    var initialVariant = findVariant();
    if (initialVariant) syncFromVariant(initialVariant);
  }

  function setupFabricPicker() {
    var pills = document.querySelectorAll('[data-kj-target-value]');
    if (!pills.length) return;
    pills.forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        e.preventDefault();
        var target = pill.getAttribute('data-kj-target-value');
        if (!target) return;
        var radios = document.querySelectorAll('variant-selects input[type="radio"]');
        var matched = null;
        radios.forEach(function (r) {
          if (r.value === target && !r.disabled) matched = r;
        });
        if (!matched) return;
        matched.checked = true;
        matched.dispatchEvent(new Event('input', { bubbles: true }));
        matched.dispatchEvent(new Event('change', { bubbles: true }));
        var vs = document.querySelector('variant-selects');
        if (vs && typeof vs.updateSelectionMetadata === 'function') {
          try { vs.updateSelectionMetadata({ target: matched }); } catch (err) {
            try { vs.updateSelectionMetadata(matched); } catch (e2) {}
          }
        }
        pills.forEach(function (p) { p.classList.toggle('is-active', p === pill); });
        var fabricLabel = document.querySelector('[data-kj-fabric-selected]');
        var pillMain = pill.querySelector('.kj-pdp__pill-main');
        if (fabricLabel && pillMain) fabricLabel.textContent = pillMain.textContent.trim();
      });
    });
  }

  function setupColorSwatchMap() {
    var colorMap = {
      'forest green': '#1f3d2a', 'forest': '#1f3d2a',
      'emerald': '#0f5a3c', 'sage': '#a4b4a0', 'olive': '#6b6f3a', 'mint': '#bce3cf',
      'hunter green': '#2c4a36', 'green': '#2f5a3c',
      'burgundy': '#5a1a26', 'wine': '#5a1a26',
      'burgundy red': '#7a1f2a', 'red': '#a83a32', 'crimson': '#8a1f2c',
      'ivory': '#f4ecdc', 'cream': '#f1e9d7', 'off-white': '#fbf8f2',
      'white': '#fdfcf9', 'snow': '#fdfcf9',
      'black': '#161616', 'charcoal': '#33342f', 'jet black': '#0f0f0f',
      'gray': '#bfbcb6', 'grey': '#bfbcb6', 'silver': '#cfcdc9',
      'navy': '#1f2d44', 'celeste blue': '#cfdbe6', 'celeste': '#cfdbe6',
      'sky': '#c8e0f0', 'powder blue': '#cfe1ee', 'light blue': '#cfdbe6',
      'blue': '#3a587a', 'cobalt': '#1f3a78', 'denim': '#4a627a',
      'blush': '#f1c8c1', 'blush pink': '#f1c8c1', 'pink': '#e8a8af',
      'rose': '#d68a92', 'dusty rose': '#c79299',
      'beige': '#d8c7a8', 'tan': '#c8a878', 'taupe': '#a89882', 'sand': '#d8c4a0',
      'gold': '#b89564', 'champagne': '#dcc59a', 'yellow': '#e8d066',
      'mustard': '#b58b3a', 'orange': '#c87a3f', 'coral': '#e08877',
      'lavender': '#c6b8d8', 'lilac': '#c6b8d8', 'purple': '#6f4a86', 'plum': '#5a3a5a',
      'brown': '#5a3e2a', 'chocolate': '#3e2a1a', 'camel': '#a17a4a'
    };
    var defaultFallback = 'rgb(229, 224, 214)';
    var swatches = document.querySelectorAll('.kj-pdp__swatch, .kj-xsell__color-dot');
    swatches.forEach(function (sw) {
      var current = (sw.style.getPropertyValue('--kj-swatch') || '').trim();
      var bg = sw.style.backgroundColor || '';
      var isDefault = !current || current === '#e5e0d6' || current === defaultFallback;
      var bgIsDefault = bg === defaultFallback || bg === 'rgb(229, 224, 214)' || bg === '#e5e0d6' || bg === '';
      if (!isDefault && !bgIsDefault) return;
      var name = (sw.getAttribute('data-color-name') || sw.getAttribute('title') || sw.getAttribute('aria-label') || '').toLowerCase().trim();
      if (!name) return;
      var base = name.split(' - ')[0].trim();
      var hex = null;
      if (colorMap[base]) { hex = colorMap[base]; }
      else {
        var tokens = base.split(/\s+/);
        for (var i = 0; i < tokens.length; i++) {
          if (colorMap[tokens[i]]) { hex = colorMap[tokens[i]]; break; }
        }
        if (!hex && tokens.length >= 2) {
          var compound = tokens.slice(-2).join(' ');
          if (colorMap[compound]) hex = colorMap[compound];
        }
      }
      if (hex) {
        sw.style.setProperty('--kj-swatch', hex);
        sw.style.backgroundColor = hex;
      }
    });
  }

  function setupStickyAtc() {
    if (window.matchMedia('(min-width: 750px)').matches) return;
    var primary = document.querySelector('.kj-pdp__atc, .product-form__submit');
    if (!primary) return;
    var bar = document.createElement('div');
    bar.className = 'kj-sticky-atc';
    bar.setAttribute('aria-label', 'Quick add to cart');
    var titleEl = document.querySelector('.kj-pdp__title, .product__title h1');
    var title = titleEl ? titleEl.textContent.trim() : '';
    var imgEl = document.querySelector('.kj-gallery__slide img, .main-product-slider__image img');
    var imgSrc = imgEl ? (imgEl.getAttribute('src') || imgEl.getAttribute('data-src') || '') : '';
    bar.innerHTML =
      '<div class="kj-sticky-atc__inner">' +
        '<div class="kj-sticky-atc__thumb">' +
          (imgSrc ? '<img src="' + escapeHtml(imgSrc) + '" alt="">' : '') +
        '</div>' +
        '<div class="kj-sticky-atc__meta">' +
          '<span class="kj-sticky-atc__title">' + escapeHtml(title) + '</span>' +
          '<span class="kj-sticky-atc__price" data-sticky-price></span>' +
        '</div>' +
        '<button type="button" class="kj-sticky-atc__btn" data-sticky-atc>Add to Bag</button>' +
      '</div>';
    document.body.appendChild(bar);
    syncStickyPrice();
    syncStickyState();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bar.classList.remove('is-visible');
          document.body.classList.remove('kj-sticky-atc-visible');
        } else if (primary.getBoundingClientRect().top < 0) {
          bar.classList.add('is-visible');
          document.body.classList.add('kj-sticky-atc-visible');
        }
      });
    }, { threshold: 0.01 });
    io.observe(primary);
    bar.querySelector('[data-sticky-atc]').addEventListener('click', function () {
      if (primary.disabled) return;
      primary.click();
    });
    var productInfo = document.querySelector('product-info, .kj-pdp');
    if (productInfo) {
      productInfo.addEventListener('change', function () {
        setTimeout(function () {
          syncStickyPrice();
          syncStickyState();
          syncStickyImage();
        }, 60);
      });
    }
    var mo = new MutationObserver(function () {
      syncStickyPrice();
      syncStickyState();
    });
    var priceContainer = document.querySelector('.kj-pdp__price, [data-fetch="price"]');
    var atcContainer = primary.parentElement;
    if (priceContainer) mo.observe(priceContainer, { childList: true, subtree: true, characterData: true });
    if (atcContainer) mo.observe(atcContainer, { childList: true, subtree: true });
  }

  function syncStickyPrice() {
    var target = document.querySelector('[data-sticky-price]');
    if (!target) return;
    var sale = document.querySelector('.kj-pdp__price-sale, [data-fetch="price"] .price-item--sale');
    var compare = document.querySelector('.kj-pdp__price-compare, [data-fetch="price"] .price-item--regular');
    var html = '';
    if (compare && compare.textContent.trim()) {
      html += '<s>' + escapeHtml(compare.textContent.trim()) + '</s>';
    }
    if (sale) html += escapeHtml(sale.textContent.trim());
    target.innerHTML = html;
  }

  function syncStickyState() {
    var primary = document.querySelector('.kj-pdp__atc, .product-form__submit');
    var stickyBtn = document.querySelector('[data-sticky-atc]');
    if (!primary || !stickyBtn) return;
    if (primary.disabled) {
      stickyBtn.disabled = true;
      stickyBtn.textContent = (primary.textContent || '').trim() || 'Sold Out';
    } else {
      stickyBtn.disabled = false;
      stickyBtn.textContent = 'Add to Bag';
    }
  }

  function syncStickyImage() {
    var imgEl = document.querySelector('.kj-gallery__slide img');
    var stickyImg = document.querySelector('.kj-sticky-atc__thumb img');
    if (imgEl && stickyImg) {
      var src = imgEl.getAttribute('src') || imgEl.getAttribute('data-src');
      if (src) stickyImg.src = src;
    }
  }

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
})();

/* ============================================================================
   Scroll indicator + desktop scroll interactions for both carousels.

   Drag pattern: we track movement on EVERY mousedown (even on tiles). If the
   user moves the mouse > DRAG_THRESHOLD pixels, we treat it as a drag-scroll:
   move the carousel and suppress the eventual click. If they don't move, the
   click passes through normally to the tile's own click handler.
   ============================================================================ */
(function () {
  var DRAG_THRESHOLD = 5;

  function init() {
    var grids = document.querySelectorAll('.template-product .influencer-gallery__grid, .template-product .kj-xsell__set');
    grids.forEach(function (grid) {
      if (grid.__kjIndicatorInit) return;
      grid.__kjIndicatorInit = true;

      var indicator = document.createElement('div');
      indicator.className = 'kj-scroll-indicator';
      var thumb = document.createElement('div');
      thumb.className = 'kj-scroll-indicator__thumb';
      indicator.appendChild(thumb);
      grid.parentNode.insertBefore(indicator, grid.nextSibling);

      function update() {
        var max = grid.scrollWidth - grid.clientWidth;
        if (max <= 0) {
          indicator.style.display = 'none';
          return;
        }
        indicator.style.display = '';
        var thumbW = Math.max(0.2, grid.clientWidth / grid.scrollWidth);
        var trackW = indicator.clientWidth;
        var thumbPx = thumbW * trackW;
        var travelPx = trackW - thumbPx;
        var pct = grid.scrollLeft / max;
        thumb.style.width = thumbPx + 'px';
        thumb.style.transform = 'translateX(' + (pct * travelPx) + 'px)';
      }
      grid.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      setTimeout(update, 50);
      setTimeout(update, 400);
      setTimeout(update, 1200);

      // Wheel: vertical wheel moves the carousel horizontally.
      grid.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        var canLeft = grid.scrollLeft > 0;
        var canRight = grid.scrollLeft + grid.clientWidth < grid.scrollWidth - 1;
        if (e.deltaY < 0 && !canLeft) return;
        if (e.deltaY > 0 && !canRight) return;
        e.preventDefault();
        grid.scrollLeft += e.deltaY;
      }, { passive: false });

      // Drag-to-scroll. We track movement on EVERY mousedown including on
      // tiles — only a click without movement passes through to the tile.
      var isDown = false;
      var startX = 0;
      var startScroll = 0;
      var moved = false;
      var dragModeActive = false; // true once we cross the threshold

      grid.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        // Don't hijack mousedown on a form control where it has meaning.
        if (e.target.closest('input, select, textarea')) return;
        isDown = true;
        moved = false;
        dragModeActive = false;
        startX = e.pageX;
        startScroll = grid.scrollLeft;
      });

      window.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var dx = e.pageX - startX;
        if (!dragModeActive && Math.abs(dx) > DRAG_THRESHOLD) {
          dragModeActive = true;
          moved = true;
          grid.style.cursor = 'grabbing';
          grid.style.userSelect = 'none';
        }
        if (dragModeActive) {
          // Prevent text/image selection during a drag.
          e.preventDefault();
          grid.scrollLeft = startScroll - dx;
        }
      });

      window.addEventListener('mouseup', function () {
        if (!isDown) return;
        isDown = false;
        if (dragModeActive) {
          grid.style.cursor = '';
          grid.style.userSelect = '';
          dragModeActive = false;
        }
      });

      // Capture-phase click guard. Only fires if the user actually dragged;
      // after firing once, resets `moved` so the next click goes through.
      grid.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);

      // Also kill `dragstart` (which fires on images) so it never blocks our drag.
      grid.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
